import { render, staticRenderFns } from "./changeRemark.vue?vue&type=template&id=5662010a&scoped=true"
import script from "./changeRemark.vue?vue&type=script&lang=ts"
export * from "./changeRemark.vue?vue&type=script&lang=ts"
import style0 from "./changeRemark.vue?vue&type=style&index=0&id=5662010a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5662010a",
  null
  
)

export default component.exports